import { render, staticRenderFns } from "./EventArticle.vue?vue&type=template&id=6fa26b24&scoped=true&"
import script from "./EventArticle.vue?vue&type=script&lang=js&"
export * from "./EventArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa26b24",
  null
  
)

export default component.exports